import { HOME_PAGE_ROUTES } from "@/data";
import { QUICK_ACTIONS_DATA_TYPE } from "@/models";
import { Call, RepeatCircle, TransactionMinus, Wifi } from "iconsax-react";

export const QuickActionData: QUICK_ACTIONS_DATA_TYPE[] = [
  {
    name: "Airtime",
    to: HOME_PAGE_ROUTES.AIRTIME,
    icon: (
      <div className="p-3 rounded-full bg-[#FFF4EC]">
        <Call color="#FF6D00" />
      </div>
    ),
  },
  {
    name: "Data",
    to: HOME_PAGE_ROUTES.DATA,
    icon: (
      <div className="p-3 rounded-full bg-[#E9FAE9]">
        <Wifi color="#006F01" />
      </div>
    ),
  },
  {
    name: "Bills",
    to: HOME_PAGE_ROUTES.BILL_PAYMENTS,
    icon: (
      <div className="p-3 rounded-full bg-[#F5FCFF]">
        <TransactionMinus color="#00B3EF" />
      </div>
    ),
  },
  {
    name: "Recurring",
    to: HOME_PAGE_ROUTES.RECURRING_PAYMENTS,
    icon: (
      <div className="p-3 rounded-full bg-[#FDF9E7]">
        <RepeatCircle color="#AA8913" />
      </div>
    ),
  },
];
